import React from "react";

import "./oportunidades.css";

const Oportunidades = () => {
  return <div>Oportunidades work!!!</div>;
};

export default Oportunidades;
